import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import MasterDetailsReport from '../../../../common/components/MasterDetailsReport';
import DespatchMonitoringReport from '../../common/components/DespatchMonitoringReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/DespatchMonitoringResponseAnalysisSelectors';

export function DespatchMonitoringResponseAnalysisContainer(props) {
  return (
    <DespatchMonitoringReport
      reportId={ReportDefinitions.DESPATCH_MONITORING_RESPONSE_ANALYSIS.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
      masterDetailsReport={new MasterDetailsReport('despatchId')}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

DespatchMonitoringResponseAnalysisContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(DespatchMonitoringResponseAnalysisContainer);

